<script lang="ts" setup>
defineOptions({
    name: 'IdeoTab'
});

const instance = getCurrentInstance();

const props = defineProps<{
    title?: string;
    active?: boolean;
    manual?: boolean;
    hidden?: boolean;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    (e: 'click', index: number): void;
}>();

const isMounted = ref(false);

const tabs = computed((): any => instance.parent);
const index = computed(() => tabs.value.exposed.tabIndex(instance));
const activeTab = computed(() => tabs.value.exposed.tabActive(instance));
const navLinkClasses = computed(() => ({
    'nav-link': true,
    'active': activeTab.value,
    'disabled': props.disabled,
    'manual': props.manual,
    ...(activeTab.value ? normalizeClasses(tabs.value?.props?.activeNavItemClass) : {})
}));
const contentClasses = computed(() => ({
    ...normalizeClasses(tabs.value?.props?.tabClass),
    ...(activeTab.value ? normalizeClasses(tabs.value?.props?.activeTabClass) : {})
}));

onBeforeMount(() =>
{
    tabs.value.exposed.registerTab(instance);
});

onMounted(() =>
{
    isMounted.value = true;
});

onUnmounted(() =>
{
    tabs.value.exposed.unregisterTab(instance);
});

const onClick = (): void =>
{
    if (props.manual)
        return;

    tabs.value.exposed.setActiveTab(instance);

    emit('click', index.value);
};
</script>

<template>
    <Portal v-if="isMounted" :to="`tabs-nav-${tabs.uid}`">
        <li v-show="!hidden" class="nav-item">
            <a :class="navLinkClasses" href="#" @click.stop.prevent="onClick">
                <slot name="title">
                    {{ title }}
                </slot>
            </a>
        </li>
    </Portal>
    <div v-show="activeTab" :class="contentClasses" :data-tab="instance.uid">
        <slot name="default" :active="activeTab" />
    </div>
</template>
